import Home from '@/views/Home.vue'

export const AppRoutes = {
  GlobalRoutes: [],
  LangRoutes  : [
    {
      name     : 'Home',
      path     : 'home',
      component: Home,
      meta     : { layout: 'default' }
    }
  ]
}

export default AppRoutes
